import React from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Typography,
} from "@mui/material";
import LockResetIcon from "@mui/icons-material/LockReset";
import EmailIcon from "@mui/icons-material/Email";
import BadgeIcon from "@mui/icons-material/Badge";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ShieldIcon from "@mui/icons-material/Shield";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuthUser from "../../hooks/useAuthUser";
import { UserRoleName } from "../../themes/Enum";
import { LocationName } from "../../themes/Enum";
import MfaSection from "./MfaSection";

const UserProfilePage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const userData = useAuthUser() || {};

  const userName = userData.name || userData.fullName || "User";
  // Preferir el roleName del backend; UserRoleName (por ID) es solo fallback.
  const userRole = userData.activeRole?.name || UserRoleName[userData.rol] || "User";
  const userLocation = LocationName[userData.location] || userData.location || "";
  const userEmail = userData.email || "";
  const employeeId = userData.employee || "";
  const userInitial = userName.charAt(0).toUpperCase();

  const infoItems = [
    { icon: <BadgeIcon fontSize="small" />, label: t("userProfile.employeeId", "Employee ID"), value: employeeId },
    { icon: <ShieldIcon fontSize="small" />, label: t("userProfile.role", "Role"), value: userRole },
    { icon: <LocationOnIcon fontSize="small" />, label: t("userProfile.location", "Location"), value: userLocation },
    { icon: <EmailIcon fontSize="small" />, label: t("userProfile.email", "Email"), value: userEmail },
  ];

  return (
    <Box sx={{ maxWidth: 520, mx: "auto", mt: 4 }}>
      <Typography variant="h5" fontWeight={600} gutterBottom>
        {t("userProfile.title", "My Profile")}
      </Typography>

      <Card sx={{ borderRadius: 3 }}>
        <CardContent sx={{ textAlign: "center", pt: 4, pb: 2 }}>
          <Avatar
            sx={{
              width: 80,
              height: 80,
              mx: "auto",
              mb: 2,
              background: "linear-gradient(135deg, #00bcd4 0%, #0C343D 100%)",
              fontSize: "2rem",
              fontWeight: 600,
            }}
          >
            {userInitial}
          </Avatar>
          <Typography variant="h6" fontWeight={600}>
            {userName}
          </Typography>
          <Chip label={userRole} size="small" color="primary" sx={{ mt: 0.5 }} />
        </CardContent>

        <Divider />

        <CardContent>
          {infoItems
            .filter((item) => item.value)
            .map((item) => (
              <Box
                key={item.label}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  py: 1.2,
                }}
              >
                <Box sx={{ color: "text.secondary" }}>{item.icon}</Box>
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {item.label}
                  </Typography>
                  <Typography variant="body2" fontWeight={500}>
                    {item.value}
                  </Typography>
                </Box>
              </Box>
            ))}
        </CardContent>

        <Divider />

        <CardContent sx={{ textAlign: "center" }}>
          <Button
            variant="outlined"
            startIcon={<LockResetIcon />}
            onClick={() => navigate("/auth/change-password")}
          >
            {t("userProfile.changePassword", "Change Password")}
          </Button>
        </CardContent>

        <MfaSection />
      </Card>
    </Box>
  );
};

export default UserProfilePage;
